/* eslint-disable */
import Backbone from 'backbone';
var DummyView = Backbone.View.extend({
  next: function () {}
});
var dummyOptions = {};
var defaultSteps = [{
  title: 'put your string for the step title here',
  description: 'put your string for the step description here',
  viewFactory: DummyView,
  options: dummyOptions
}];
var Model = Backbone.Model.extend({
  defaults: {
    steps: defaultSteps,
    stepIndex: 0
  }
});
export default Model;

